import React from "react";
import {CenteredDesign} from "../../../../../components/DesignSystem/CenteredDesign/CenteredDesign";
import PropTypes from "prop-types";
import {Row, Col, Skeleton, Button} from "antd";
import {ChatUploadData} from "./ChatUploadData";
import {AvailableFiles} from "../../../../../components/File/AvailableFiles";
import {Spacer} from "../../../../../components/DesignSystem/Spacer/Spacer";
import {SelectChatModal} from "../../../ai-assistant/SelectChatModal";

export const ChatsPage = ({user}) => {

    const [showSelectChatModal, setShowSelectChatModal] = React.useState(false);

    const handleShowChats = () => {
        setShowSelectChatModal(true);
    }

    const handleCloseChats = () => {
        setShowSelectChatModal(false);
    }

    if (!user) {
        return <Skeleton/>
    }

    return <CenteredDesign>
        <Row justify={"middle"}>
            <Col sm={12}>
                <h2>Hello, {user.firstName} </h2>
                <h4>To get started, please upload your data or choose a file from the list</h4>
            </Col>
            <Col sm={12} align="right">
                <Button onClick={handleShowChats}>Show chats</Button>
            </Col>
        </Row>

        {showSelectChatModal && <SelectChatModal onClose={handleCloseChats}/>}


        <ChatUploadData fileUploadLimit={user?.companyPlan?.fileUploadLimit} user={user}/>
        <Spacer/>
        <AvailableFiles user={user}/>
    </CenteredDesign>

}

ChatsPage.propTypes = {
    user: PropTypes.object.isRequired
}